module.exports = __webpack_public_path__ + "media/reskin-images/icon--plus-c19b05a8.svg";